import { Flex, Form, FormInstance, Input, InputNumber, Typography } from 'antd';
import classes from '../Sepa.module.scss';
import React from 'react';
import { Account } from '../../../../types';
import { SepaForm } from '../model/types';
import { getSendSepaScheme } from '../model/scheme';
import SelectCard from '../../../../components/AccountDropdown/SelectCard';
import { BlackButton } from 'common/components/UI';
import { useIntl } from 'react-intl';

const { Title, Text } = Typography;
const { TextArea } = Input;

type AmountProps = {
  currentFrom: Account;
  onCancel: () => void;
  fee: number;
  formValues: Partial<SepaForm>;
  form: FormInstance;
}

const Amount: React.FC<AmountProps> = ({
                                       currentFrom,
                                       onCancel,
                                       fee,
                                       formValues,
                                       form,
                                     }) => {
  const { formatMessage: t } = useIntl();
  const rules = getSendSepaScheme(t);

  return (
    <Flex vertical gap={12}>
      <Title level={3}>{t({ id: 'screens.payment.create.beneficiary.title' })}</Title>
      <Flex vertical gap={24}>
        <Flex vertical gap={8}>
          <Text style={{
            fontSize: 16,
            lineHeight: '20px',
          }}>
            {t({ id: 'noty.card.from' })}:
          </Text>
          <SelectCard
            currentOption={currentFrom}
            className='card_disabled'
          />
        </Flex>
        <Form initialValues={formValues} form={form} name="amount">
          <Flex vertical gap={8}>
            <Text>{t({ id: 'noty.card.to' })}:</Text>
            <Flex vertical>
              <Form.Item name="beneficiary">
                <Input
                  size="large"
                  disabled
                  placeholder={t({ id: 'sections.load.load.sepa.recipient' })}
                />
              </Form.Item>
              <Form.Item name="iban">
                <Input
                  disabled
                  size="large"
                  placeholder={t({ id: 'screens.payment.create.beneficiary.inputs.iban' })}
                />
              </Form.Item>
            </Flex>
          </Flex>
          <Flex vertical>
            <Form.Item name="amount">
              <InputNumber
                addonBefore='€'
                disabled
                placeholder={t({ id: 'noty.card.amount' })}
                rootClassName={classes['input']}
              />
            </Form.Item>
            <Text style={{ fontSize: 14 }}>
              {t({id: 'screens.payment.create.beneficiary.inputs.amount.info3'}, {amount: (form.getFieldValue('amount') ?? 0) + fee, fee: fee})} 
            </Text>
          </Flex>
          <Flex vertical gap={8} style={{marginTop: 16}}>
            <Text>{t({ id: 'screens.payment.create.create.nav.amount' })}</Text>
            <Form.Item name="confirmAmount" rules={rules.confirmAmount}>
              <InputNumber
                addonBefore='€'
                placeholder={t({ id: 'screens.payment.create.beneficiary.inputs.amount' })}
                rootClassName={classes['input']}
              />
            </Form.Item>
          </Flex>
          <Form.Item name="description"  rootClassName={classes['description']}>
            <TextArea
              disabled
              autoSize={{ minRows: 3, maxRows: 5 }}
              placeholder={t({ id: 'screens.payment.create.beneficiary.inputs.details' })}
            />
          </Form.Item>
          <Flex gap={8}>
            <BlackButton
              htmlType="submit"
              type="primary"
            >
              {t({ id: 'buttons.send' })}
            </BlackButton>
            <BlackButton
              onClick={onCancel}
            >
              {t({ id: 'button.simple.cancel' })}
            </BlackButton>
          </Flex>
        </Form>
      </Flex>
    </Flex>
  );
};

export default Amount;